import { tns } from 'tiny-slider/src/tiny-slider'

export default class Slider {
  constructor (container, controls) {
    this.el = container
    this.controls = controls

    if (container) {
      this.slider = tns({
        container,
        nav: false,
        controls: false,
        autoWidth: true,
        arrowKeys: true
      })
    }

    if (controls) {
      for (let item of controls) {
        item.addEventListener('click', ({ currentTarget }) => {
          let index = currentTarget.dataset.index || 0
          this.slider.goTo(index)
        })
      }
    }
  }
}
